import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { snapSignInModule } from './modules/auth';
import { portalPlugin } from './modules/portal';

export default createApp({ features: [catalogPlugin, navModule, portalPlugin, snapSignInModule] });
